/**
 * 위치 설정 (/m/setting/gps) — 현위치·차고지 지도 두 장, 차고지 수정(장비가 여럿이면 고르는 오버레이), 가상번호 시트
 * ($j.Pages.Mobile.SettingGps / body data-page-name="SettingGps")
 *
 * 구 public/js/m-gps.js (전역 함수 묶음)를 옮긴 것. window.callbackAddress 는 지도 창(KakaoMap)이
 * 고른 주소를 돌려주는 약속이라 window 에 둔다.
 */
let D = {};               // 서버 값 (#page-data)
let driversList = [];     // 차고지를 고칠 장비 [번호, 차량번호, 기사명]

export default class SettingGps {
    initialize() {
        D = JSON.parse(document.getElementById('page-data')?.textContent || '{}');
        window.callbackAddress = callbackAddress;

        const ACT = {
            refresh: (el) => $j.F.App.refreshMyPosition(Number(el.dataset.mb)),
            garage:  () => preCarSelect(),
            vnum:    () => carSetOpen(),
        };
        $('[data-gps]').on('click', function () { ACT[this.dataset.gps](this); });

        // 장비 고르기 오버레이 (body 직속에 그린다)
        $(document)
            .on('click', '#driverselectordiv .sgp-pick-item', function () { pickCar(Number(this.dataset.no), Number(this.dataset.idx)); })
            .on('click', '#driverselectordiv .sgp-pick-cancel', () => closeSelector())
            .on('click', '#driverselectordiv .sgp-pick-ok', () => selectCarGo());

        initMaps();
        if (D.mode == 'v') carSetOpen();
    }
}

/** 차고지 수정 — 장비가 하나면 바로 지도, 여럿이면 고르는 오버레이부터 */
function preCarSelect() {
    driversList = [];
    // #driverslists = "번호/차량번호/기사명|..."
    document.getElementById('driverslists').value.split('|').forEach((line) => {
        if (line.length <= 5) return;
        const p = line.split('/');
        if (p.length <= 1) return;
        const no = parseInt(p[0]) || 0;
        if (no > 2) driversList.push([no, p[1], p[2]]);
    });
    if (driversList.length < 2) $j.F.KakaoMap.open(`${D.baseloc[0]}, ${D.baseloc[1]}`);
    else openSelector();
}

/** 어느 장비의 차고지를 고칠지 고르는 오버레이. 색·모양은 pages/_setting-gps.scss (.sgp-pick-*) */
function openSelector() {
    const esc = (v) => $j.Common.Util.escapeHtml(String(v ?? ''));
    let hh = "<div class='sgp-pick-panel'><div class='sgp-pick-hd'>변경할 장비선택</div><div class='sgp-pick-list'>";
    driversList.forEach(([no, plate, name], i) => {
        hh += `<button type='button' class='sgp-pick-item' id='adrsetcarnum_${i}' data-no='${no}' data-idx='${i}'>`
            + "<i class='far fa-circle'></i>"
            + `<span class='sgp-pick-name'>${esc(name)}</span>`
            + `<span class='sgp-pick-plate'>${esc(plate)}</span>`
            + '</button>';
    });
    hh += "</div><div class='sgp-pick-btns'>"
        + "<button type='button' class='sgp-pick-cancel'>취소</button>"
        + "<button type='button' class='sgp-pick-ok' id='changefdinfo'>확인</button>"
        + '</div></div>';
    const div = document.createElement('div');
    div.className = 'sgp-pick';
    div.id = 'driverselectordiv';
    div.innerHTML = hh;
    document.body.appendChild(div);
}

function closeSelector() {
    const obj = document.getElementById('driverselectordiv');
    if (obj) obj.remove();
}

function pickCar(no, idx) {
    $('#driverselectordiv .sgp-pick-item').each(function (i) {
        const on = (i === idx);
        this.classList.toggle('is-on', on);
        // 라디오 글리프 — 구 화면은 radio_on/off.png 두 장을 갈아끼웠다
        this.querySelector('i').className = on ? 'fas fa-circle-dot' : 'far fa-circle';
    });
    document.getElementById('drivernum').value = no;
    $('#changefdinfo').data('num', idx);
}

function selectCarGo() {
    const idx = $('#changefdinfo').data('num');
    if (idx === undefined) { $j.Common.Util.swalert('장비를 선택해 주세요'); return; }
    closeSelector();
    $j.F.KakaoMap.open(`${D.carPArray[idx][0]}, ${D.carPArray[idx][1]}`);
}

/** 가상번호 설정 BS — 서류등록(/m/docs/v1)과 공용 모듈 */
function carSetOpen() {
    $j.Ui.BS.open({ target: '$j.F.Mobile.VnumSheet', fixedHeight: true });
}

function initMaps() {
    if (window.daum) {
        D.memArray.length > 1 ? showMapMulti(1) : showMap(1, D.myloc[0], D.myloc[1]);
        D.carPArray.length > 1 ? showMapMulti(2) : showMap(2, D.baseloc[0], D.baseloc[1]);
    } else {
        alert('No Daumset');
    }
    if (D.showMd == 'numset') carSetOpen();
}

/** 지도에 여러 장비(1: 현위치 / 2: 차고지)를 이름표로 찍는다 */
function showMapMulti(n) {
    const mapContainer = document.getElementById('map' + n);
    mapContainer.style.display = 'block';
    mapContainer.style.height = '300px';

    const icons = ['sv_gpsicon_00', 'sv_gpsicon_01', 'sv_gpsicon_02', 'sv_gpsicon_03', 'sv_gpsicon_04'];
    let ic = 0;
    const bounds = new daum.maps.LatLngBounds();
    const list = (n == 1) ? D.memArray : D.carPArray;
    const map = new daum.maps.Map(mapContainer, { center: new daum.maps.LatLng(list[0][0], list[0][1]), level: 5 });

    list.forEach((row) => {
        if (row.length <= 1) return;
        const [x, y] = row;
        const title = String(row[2] ?? '').replace(',', '');
        const lat = parseFloat(x) || 0;
        if (!(lat > 20 && lat < 50)) return;
        const pos = new daum.maps.LatLng(x, y);
        // 이름표 + 아이콘 — 모양은 _setting-gps.scss (.sgp-mk-*). 이름표 가로 위치는 그린 뒤 폭으로 맞춘다
        const content = "<div class='sgp-mk'><div class='sgp-mk-tag'><span class='sgp-mk-txt'>" + $j.Common.Util.escapeHtml(title)
            + "</span></div><img src='/img/m/" + icons[ic] + ".svg' class='sgp-mk-ic'></div>";
        ic = (ic + 1) % icons.length;
        const overlay = new daum.maps.CustomOverlay({ map, position: pos, content, yAnchor: 1 });
        bounds.extend(pos);
        overlay.setMap(map);
        map.relayout();
    });
    map.setBounds(bounds);
    map.relayout();
    // 이름표를 아이콘 위 가운데쯤으로 (구 checkPos — img onload)
    $(mapContainer).find('.sgp-mk-ic').each(function () {
        const fit = () => {
            const tag = this.parentNode.firstChild;
            tag.style.left = '-' + parseInt(tag.getBoundingClientRect().width / 2.7) + 'px';
        };
        if (this.complete) fit(); else this.addEventListener('load', fit);
    });
}

function showMap(n, x, y) {
    const mapContainer = document.getElementById('map' + n);
    mapContainer.style.display = 'block';
    mapContainer.style.height = '250px';
    const map = new daum.maps.Map(mapContainer, { center: new daum.maps.LatLng(x, y), level: 3 });
    const marker = new daum.maps.Marker({ position: new daum.maps.LatLng(x, y) });
    map.relayout();
    marker.setMap(map);
    // 관리자면 지도 초기화 후에도 현위치 지도를 다시 숨긴다 (위치정보 보호)
    if (n == 1 && D.map1Display == 'none') mapContainer.style.display = 'none';
    if (n == 2 && D.map2Display == 'none') mapContainer.style.display = 'none';
}

/**
 * 지도에서 고른 주소로 차고지 저장 — 지도 창이 부른다
 * @param arr ( lat : 위도, long : 경도, addr : 주소, place : 장소 이름 )
 */
function callbackAddress(arr) {
    document.userpossave.addr.value = arr['addr'];
    document.userpossave.pos.value = arr['lat'] + ',' + arr['long'];
    $.ajax({
        type: 'post',
        url: '/m/ajax/member/gps',
        data: $('#userpossave').serialize(),
        dataType: 'json',
        success: function () { document.location.href = '/m/setting/gps'; },
    });
}
